import {
    authenticatedFetch,
} from '$lib/backend';


export const prerender = true;
export const ssr = false;

// src/routes/+layout.js
/** @type {import('./$types').LayoutLoad} */
export async function load({ fetch }) {
    const gdata = await authenticatedFetch('/config', { credentials: 'include', }, fetch);
    gdata.signals = new Map(gdata.signals)
    return { gdata };
}
